import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import Img10 from '../../img/10.png';
import Img11 from '../../img/11.png';
import Img12 from '../../img/12.png';
import Img15 from '../../img/15.png';
import Img16 from '../../img/16.png';
import Img17 from '../../img/17.png';
import HrImg from '../../img/hr-maru.png';

const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header =styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const HumanImg =styled.img`
    border-radius: 50%;
`
const HumanP =styled.p`padding-left: 62px;`
const ImgCenter =styled.div`justify-items: center;`

const ParentVoice: React.VFC = () => {
  return (
    <Main>
        <p className='text-center text-2xl font-bold'>保護者様からの声</p>
        <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
        
        <ImgCenter className='mt-3 grid grid-cols-3 gap-4 sm:grid-cols-3 md:grid-cols-6'>
            <div className='col-span-3'>
                <div>
                    <img src={Img10} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Img11} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Img12} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Img16} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Img15} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Img17} alt="" />
                </div>
            </div>
        </ImgCenter>
        
    </Main>
    
  );
}
export default ParentVoice;